export const env = {
  baseURL: process.env.REACT_APP_ARCH_API_BASE_URL as string,
  baseURL_monarch: process.env.REACT_APP_MONARCH_API_BASE_URL as string,
  baseURL_sat: process.env.REACT_APP_SAT_API_BASE_URL as string,
  workspaceId: process.env.REACT_APP_WORKSPACE_ID as string,
  organization_mode: process.env.REACT_APP_ORGANIZATION_MODE as string,
  environment: process.env.REACT_APP_ENVIRONMENT as string,
  REACT_APP_STORAGESASTOKEN: process.env.REACT_APP_STORAGES_AS_TOKEN as string,
  REACT_APP_STORAGERESOURCENAME: process.env
    .REACT_APP_STORAGE_RESOURCE_NAME as string,
  signalrConnectionUrl: process.env.REACT_APP_SIGNALR_CONNECTION_URL as string,
  CUBE_API_URL: process.env.REACT_APP_CUBE_API_URL as string,
  LogicApp_CustomEmail: process.env.REACT_APP_LOGIC_APP_CUSTOM_EMAIL as string,
  LogicApp_TicketNotification: process.env
    .REACT_APP_LOGIC_APP_TICKET_NOTIFICATION as string,
  LogicApp_CommentMention: process.env
    .REACT_APP_LOGIC_APP_COMMENT_MENTION as string,
  LogicApp_RoleNotification: process.env
    .REACT_APP_LOGIC_APP_ROLE_NOTIFICATION as string,
  LogicApp_UserAddDeleteNotification: process.env
    .REACT_APP_LOGIC_APP_USER_ADD_DELETE_NOTIFICATION as string,
  LogicApp_PreferenceModification: process.env
    .REACT_APP_LOGIC_APP_PREFERENCE_MODIFICATION as string,
  Azure_DevOps_Build_Number: process.env
    .REACT_APP_AZURE_DEVOPS_BUILDNUMBER as string,
  LogicApp_SATEmailTrigger: process.env
    .REACT_APP_LOGIC_APP_SAT_EMAIL_TRIGGER as string,
  APPLICATION_INSIGHTS_INTRUMENT_KEY: process.env
    .REACT_APP_APPLICATION_INSIGHTS_INTRUMENT_KEY as string,
  monarch_app_url: process.env.REACT_APP_MONARCH_APP_URL as string,
  eam_service_workorders_mgt: process.env
    .REACT_APP_eam_service_workorders_mgt as string,
  eam_service_assets_mgt: process.env.REACT_APP_eam_assets_mgt as string,
  eam_syncfusion_license: process.env
    .REACT_APP_eam_syncfusion_license as string,
  Injection_Machine_Assets_Share_Point_Url: process.env
    .REACT_APP_INJECTION_MACHINE_ASSETS_SHARE_POINT_URL as string,
  Injection_Mold_Assets_Share_Point_Url: process.env
    .REACT_APP_INJECTION_MOLD_ASSETS_SHARE_POINT_URL as string,
  AI_url_version: process.env.REACT_APP_AI_URL_VERSION as string,
  AI_url: process.env.REACT_APP_AI_URL as string,
  QUALITY_CONTROL_TRENDS_WAREHOUSE_ID: process.env
    .REACT_APP_QUALITY_CONTROL_TRENDS_WAREHOUSE_ID as string,
  microservice_assetsmgt: process.env
    .REACT_APP_MICROSERVICE_ASSETSMGT as string,
  DATABRICKS_WAREHOUSE_FOR_LGV: process.env
    .REACT_APP_DATABRICKS_WAREHOUSE_FOR_LGV as string,
  FETCH_CALENDAR_API_TAGS_LIMIT: process.env
    .REACT_APP_FETCH_CALENDAR_API_TAGS_LIMIT as string,
  aseptic_CIP_function_URL: process.env
    .REACT_APP_aseptic_CIP_function_URL as string,
  Injection_FunctionApp_Baseurl: process.env.REACT_APP_INJECTION_FUNCTION_APP as string,
  azure_Insights_Logger_CubeCalls_Tracking: process.env.REACT_APP_azure_Insights_Logger_CubeCalls_Tracking as string,
  sec_FunctionApp_Baseurl : process.env.REACT_APP_SEC_FUNCTION_APP_BASEURL as string,
  getDataFromDatabricks_function_URL : process.env.REACT_APP_GET_DATA_FROM_DATABRICKS_FUNCTION_URL as string,
  DATADOG_APPLICATION_ID: process.env.REACT_APP_DD_APP_ID as string,
  DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DD_CLIENT_TOKEN as string,
  DATADOG_SITE: process.env.REACT_APP_DD_SITE as string,
  DATADOG_SERVICE: process.env.REACT_APP_DD_SERVICE as string,
  DATADOG_ENV: process.env.REACT_APP_DD_ENV as string,
  APP_VERSION: process.env.REACT_APP_VERSION as string,
  DATABRICK_REFRESH_RATE_ASP_CIP: process.env.REACT_APP_DATABRICK_REFRESH_RATE_ASP_CIP as string,
  AZURE_MAPS_SUBSCRIPTION_KEY: process.env.REACT_APP_AZURE_MAPS_SUBSCRIPTION_KEY as string,
};
